<div class="lokos-input">
    @if (label) {
        <mat-label>
            {{ label | translate }}
            <span class="required">{{ required ? '*' : '' }}</span>
        </mat-label>
    }
    <mat-form-field
        appearance="outline"
        [ngClass]="readonly ? 'mat-mdc-form-field-disabled' : ''"
    >
        @if (isAmount) {
            <span matTextPrefix class="amount-prefix">₹&nbsp;</span>
        }
        @if (isAmount) {
            <input
                matInput
                finNoScriptTag
                [name]="label"
                [placeholder]="placeholder | translate"
                [readonly]="readonly"
                [required]="required"
                [type]="'text'"
                [value]="displayValue"
                [errorStateMatcher]="matcher"
                (focus)="onAmountFocus(); afterFocus.emit($event)"
                (blur)="onAmountBlur($event)"
                (input)="onAmountInput($event)"
                (keypress)="keyPressEvent.emit($event)"
                [matTooltip]="control.value || (placeholder | translate)"
                [attr.minlength]="minLength"
                [attr.maxlength]="maxLength"
                [disabled]="readonly"
            />
        } @else {
            <input
                matInput
                finNoScriptTag
                [placeholder]="placeholder | translate"
                [value]="value"
                [name]="label"
                [formControl]="control"
                [readonly]="readonly"
                [required]="required"
                [errorStateMatcher]="matcher"
                (blur)="afterBlur.emit($event)"
                (keypress)="keyPressEvent.emit($event)"
                (focus)="afterFocus.emit($event)"
                (input)="afterInput.emit($event)"
                [type]="type"
                [matTooltip]="control.value || (placeholder | translate)"
                [min]="minValue"
                [max]="maxValue"
                [minlength]="minLength"
                [maxlength]="maxLength"
                [disabled]="readonly"
            />
        }
        @if (iconPosition === iconPositions.RIGHT) {
            <img
                [src]="iconPath"
                alt="icon"
                matSuffix
                (click)="afterIconClick.emit(iconPositions.RIGHT)"
            />
        }
        @if (iconPosition === iconPositions.LEFT) {
            <img
                [src]="iconPath"
                alt="icon"
                matPrefix
                (click)="afterIconClick.emit(iconPositions.LEFT)"
            />
        }
    </mat-form-field>
    @if (control.invalid && (control.dirty || control.touched)) {
        <mat-error>{{ getErrorMessage() }}</mat-error>
    }
</div>
